if (!customElements.get('cart-drawer-info-slider')) {
  class CartDrawerInfoSlider extends HTMLElement {
    constructor() {
      super();

      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', (e) => {
          this.init();
        });
      }
      this.init();


    }

    init() {

      var swiperArea = document.querySelector('.cart-drawer__swiper');
      if (!swiperArea) return;

      // Count slides to determine if loop mode is viable
      var slideCount = swiperArea.querySelectorAll('.swiper-slide').length;
      var canLoop = slideCount > 1;

      this.slider = new Swiper(swiperArea, {
        direction: 'vertical',
        slidesPerView: 1,
        loop: canLoop,
        allowTouchMove: false,
        autoplay: canLoop ? {
          delay: 5000,
        } : false
      });
    }
  }

  customElements.define('cart-drawer-info-slider', CartDrawerInfoSlider);
}
